export default {
  lang: 'English',
  loginView: {
    title: 'Travel Professional Training and Sales Enablement Program',
    newUser: 'New User',
  },
  register: {
    agency: 'Agency',
    email: 'Email',
    firstName: 'First name',
    lastName: 'Last name',
    agencyName: 'Agency name',
    state: 'State',
    back: 'Back',
    register: 'Register',
  },
  directory: {
    search: 'Search directory',
    placesAndDestinations: 'Places and Destinations',
  },
  footer: {
    legal: 'Legal',
    customerService: 'Customer Service',
    contact: 'Contact',
    poweredBy: 'Powered by: {TravProMobile}',
  },
  sellingPoints: {
    0: 'All new content, insider tips, videos and more',
    1: 'Enhance your knowledge, increase your sales',
    2: 'Incentives (by market) for completion of program',
    3: 'Links to social media channels',
    4: 'Easy to use tools to help you sell more',
  },
  email: {
    email: 'Email',
    agent: 'I\'m not an agent',
    submit: 'Submit',
    headerTop: 'Please enter your email address to confirm that you are',
    headerBottom: 'a travel professional.',
    welcome: {
      headerTop: 'Welcome to the',
      headerBottom: 'Barceló Sales Companion!',
    },
  },
  loginForm: {
    registered: 'The email address is already registered',
  },
  home: {
    experience: 'React Demo',
    caribbean: 'Sales Companion',
    search: 'Search...',
    welcome: {
      super: 'Start',
      title: 'Training',
      button: 'Start Training',
    },
    essentials: 'Learn the essentials to become a great Travel Agent',
    searchDirectory: 'Search directory',
  },
  fastFacts: {
    contentHeader: {
      title: 'FAST FACTS',
      subtitle: 'Download items and suggestions',
    },
    view: 'View',
  },
  dropdown: {
    reportCard: 'Report Card',
    settings: 'Settings',
    logOut: 'Log out',
  },
  nav: {
    home: 'Home',
    training: 'Training',
    fastFacts: 'Fast Facts',
    toolbox: 'Toolbox',
    directory: 'Directory',
    profile: 'Profile',
    search: 'Search',
    favorites: 'Favorites',
    logout: 'Logout',
    searchDirectory: 'Search directory',
    reportcard: 'Reportcard',
    accountSettings: 'Account Settings',
    help: 'Help',
  },
  trainingCard: {
    minutes: ' pages in this training',
    retain: 'View Training page',
    start: 'View Training page',
    continue: 'View Training page',
  },
  trainingContent: {
    next: 'Next',
    previous: 'Previous',
    overview: 'Return to overview',
    confirm: 'Confirm answer',
  },
  pageNotFound: {
    super: 'Uh oh...',
    title: '404 Page Not Found!',
    button: 'Home',
  },
  notLoggedIn: {
    super: "You're not logged in",
    title: 'You need to be logged in to view this content',
    button: 'Login',
  },
  test: 'Do not translate - never seen',
  questions: {
    arrangeTheWords: 'Click the words in the correct order to complete the sentence, then click Submit:',
    matchTheSentence: 'Click a phrase on the left, then click its match on the right. Match all pairs to complete the question.',
  },
  smartAssist: {
    title: 'TA SmartAssist',
    pastConversations: 'Past Conversations',
    showNextSuggestionsAria: 'Show next suggestions',
    headingAria: 'Open TA SmartAssist',
    headingResumeAria: 'Resume conversation',
    homePlaceholder: 'Ask anything about travel in {destinationLabel}…',
    recentConversations: 'Recent Conversations',
    previousConversations: 'Previous Conversations',
    noRecentConversations: 'No recent conversations',
    deleteConversationAria: 'Delete conversation',
    chatSubtitle: 'Ask TA Smart Assist Anything About Travel in {destinationLabel}',
    startNewConversationAria: 'Start new conversation',
    sourcesFromApp: 'Sources',
    loadingConversation: 'Loading conversation…',
    welcomePrompt: 'Ask any travel related questions about {destinationLabel}',
    loadingResponse: 'Thinking…',
    messageLimitReached: 'Message limit reached',
    messageRemaining: '{remaining} message remaining',
    messagesRemaining: '{remaining} messages remaining',
    quotaBarAria: '{remaining} of {total} messages remaining',
    resetsAt: 'Resets {resetLabel}',
    quotaChaptersPrompt: 'Earn certification for unlimited usage.',
    chatPlaceholder: 'Ask any travel related questions…',
    greetingFallback: 'Hi there',
    greetingName: 'Hi {firstName}',
    defaultDestination: 'this destination',
    appNotReady: 'App not configured yet.',
    signInRequired: 'Please sign in to continue.',
    genericError: 'Something went wrong. Please try again.',
    requestFailed: 'Request failed. Please try again.',
    sourceFallback: 'Source',
    fallbackSuggestions: {
      bestBeaches: 'Best beaches',
      familyActivities: 'Family activities',
      hiddenGems: 'Hidden gems',
      roadTrips: 'Road trips',
      dining: 'Best dining spots',
      events: 'Upcoming events',
    },
    structured: {
      confidenceThreshold: 'Confidence',
      confidenceThresholdPercentAria: 'Confidence: {percent}%',
      recommendation: 'Recommendation',
      alignment: 'Alignment Check',
      tailor: 'To Tailor Further',
      tips: 'Efficiency Tips',
    },
  },
  imageGallery: {
    noticeTitle: 'Image Usage Notice',
    noticeText: 'All images are licensed exclusively to {clientName} and may not be used without permission',
  },
};